{
  "expandButtonOpen": "Se detaljer",
  "expandButtonClose": "Skjul detaljer"
}
